import { authStorage } from '@shared/api/client/auth-storage';
import { isMemoryChallengeAction } from '@entities/security/@x/auth';
import type { AuthAction, AuthLoginOptions, AuthResponse, User } from '../model/types';

export type { AuthLoginOptions };

export type AuthLoginFn = (
  token: string,
  userFromResponse?: User,
  options?: AuthLoginOptions,
) => Promise<User | undefined>;

export interface ApplyAuthResponseOptions {
  rememberMe?: boolean;
}

export async function applyAuthResponse(
  authResponse: AuthResponse,
  authLogin: AuthLoginFn,
  options?: ApplyAuthResponseOptions,
): Promise<{ action?: AuthAction }> {
  const { tokens, action, user } = authResponse;
  const accessToken = tokens.accessToken;
  const storageOptions = { remember: options?.rememberMe };

  if (isMemoryChallengeAction(action)) {
    return { action };
  }

  if (action === 'confirm_email') {
    authStorage.setAccessToken(accessToken, storageOptions);
    return { action };
  }

  if (action === 'login_success' || !action) {
    await authLogin(accessToken, user, options);
    return { action };
  }

  authStorage.setAccessToken(accessToken, storageOptions);
  return { action };
}
